import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect, useContext } from 'react'
import { isEmpty } from 'underscore';
import { Context } from '../../..';
import DocumentsService from '../../../services/DocumentsService';

interface ItemProps {
    item: {
        id: number,
        chapter: string;
    },
    setPopov: (value: boolean) => void,
    setTitle: (value: string) => void,
    docData: object,
    setDocData: (value: any) => void
};

const Item = (props: ItemProps) => {
    const { item, setPopov, setTitle, docData, setDocData } = props;
    const { id, chapter } = item;

    const onClick = () => {
        setDocData({ ...docData, 'chapter': id });
        setPopov(false);
        setTitle(chapter);
    };

    return (
        <div className="form-check" onClick={() => onClick()} >
            &#8226;&nbsp;<label className="form-check-label" htmlFor={`item${id}`}>{chapter}</label>
        </div>
    );
};

interface Props {
    docData: any,
    setDocData: (value: object) => void,
    cleanData: boolean,
    setCleanData: (value: boolean) => void,
};

export const DocumentChapterModal: FC<Props> = ({ docData, setDocData, cleanData, setCleanData }) => {
    const { store } = useContext(Context);
    const [chapters, setChapters] = useState<[]>([]);
    const [newItem, setNewItem] = useState('');
    const [popov, setPopov] = useState<boolean>(false);
    const [title, setTitle] = useState<string>(docData.chapter && docData.chapter.length ? docData.chapter.chapter : '');
    const [popover, setPopover] = useState<boolean>(false);

    const getChapters = async () => {
        const res = await DocumentsService.getChapters();
        setChapters(res.data.results);
    };

    useEffect(() => {
        getChapters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (cleanData) {
            setTitle('');
            setCleanData(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanData]);


    const getItems = () => {
        if (!isEmpty(chapters)) {
            return chapters.map(item => <Item key={item['id']} {...{ item, setPopov, setTitle, docData, setDocData }} />);
        } else {
            return <span><Trans>Nothing found</Trans></span>
        }
    };

    const openPopov = (e: React.ChangeEvent<any>) => {
        setPopov(true);
        e.target.value = ''
    };

    const closePopov = () => {
        setPopov(false);
    };

    const add = async () => {
        try {
            await DocumentsService.createChapters(newItem);
            getChapters();
        } catch (e) {
            console.log(e);
        };
    }

    return (
        <div className="form-group" style={{ position: "relative" }}>
            <div className="input-group">
                <div className="input-group-control w-100">

                    <input type="text" className="form-control"
                        placeholder={store.lang === 'ba' ? 'Бүлекте һайлағыҙ' : store.lang === 'ru' ? 'Выберите раздел' : 'Choose a chapter'}
                        value={title}
                        title={title}
                        readOnly
                        autoComplete="off"
                        onClick={(e: React.ChangeEvent<any>) => openPopov(e)}
                        onChange={() => { }} />
                </div>
            </div>
            {popov ?
                <div className="form-group popov">
                    <div className="popov__title d-flex justify-content-between">
                        <div>
                            <button type='button' className='btn btn-light' value='' onClick={() => setPopover(true)}><i className='icon add' /><Trans>Add a new chapter</Trans></button>
                        </div>
                        <div>
                            <input type='button' className='btn text-primary' value={store.lang === 'ba' ? 'Ябырға' : store.lang === 'ru' ? 'Закрыть' : 'Close'} onClick={() => { closePopov() }} />
                        </div>
                    </div>
                    <div className="form-group">
                        {!popover ?
                            getItems()
                            :
                            <div className="form-control">
                                <input type="text" className="form-control"
                                    placeholder={store.lang === 'ba' ? 'Бүлектең исемен индерегеҙ' : store.lang === 'ru' ? 'Введите название раздела' : 'Enter the name of chapter'}
                                    autoComplete="off"
                                    onChange={(e: React.ChangeEvent<any>) => setNewItem(e.target.value)} />
                                <div className='text-center'>
                                    <input type='button'
                                        onClick={() => { add(); setPopover(false) }}
                                        value={store.lang === 'ba' ? 'Өҫтәргә' : store.lang === 'ru' ? 'Добавить' : 'Add'}
                                        className="btn btn-gray m-1" />
                                    <input type='button'
                                        onClick={() => setPopover(false)}
                                        value={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
                                        className="btn btn-gray m-1" />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                : null}
        </div>
    );
};